import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'
import { addMinutes, format, isPast, parseISO } from 'date-fns'
import { sendSolicitation, updateSolicitation } from '../../services/solicitations'
import { SOLICITATION_CATEGORY } from '../../utils/constants'
import Swal from 'sweetalert2'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'

import { Textarea } from '../../components/Form'
import { RootContext } from '../../context/rootContext'
import serviceIcon from '../../assets/icons/comb-scissors-duo.svg'
import obsIcon from '../../assets/icons/commentary-duotone.svg'
import dogIcon from '../../assets/icons/dog-duotone.svg'
import ferretIcon from '../../assets/icons/ferret.svg'
import pigIcon from '../../assets/icons/guinea-pig.svg'
import personIcon from '../../assets/icons/person-duotone.svg'
import rabbitIcon from '../../assets/icons/rabbit.svg'
import phoneIcon from '../../assets/icons/telephone-duotone.svg'
import chatProcessingIcon from '../../assets/icons/chat-processing.svg'
import catIcon from '../../assets/icons/cat.svg'
import {
  Header,
  Body,
  Item,
  Icon,
  Description,
  Footer,
  ButtonOpen,
  SchedulerTime,
  NotificationCircle,
  Question,
  TextAreaContent,
  MaxCaracters,
  PendingAnswer,
  QuestionContent,
  ButtonSubmit,
  AdditionalServices
} from './styles'

const Scheduling = ({
  item: {
    id,
    obs = '',
    userName,
    userPhone,
    date,
    duration = 30,
    service,
    additionalServices,
    pet,
    isOverbook,
    solicitation: {
      id: solicitationId,
      answerMessage,
      questionMessage,
      answerRead,
      kind
    }
  }
}) => {
  const [open, setOpen] = useState(false)
  const [questionLabelMessage, setQuestionLabelMessage] = useState(questionMessage)
  const [newQuestionMessage, setNewQuestionMessage] = useState('')
  const [newAnswerMessage, setNewAnswerMessage] = useState(answerMessage)
  const [notificationRead, setNotificationRead] = useState(answerRead)
  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const timeStart = format(parseISO(date), 'HH:mm')
  const timeEnd = format(addMinutes(parseISO(date), duration), 'HH:mm')
  const { handleUpdateSolicitation } = useContext(RootContext)

  const breedIcons = {
    DOG: dogIcon,
    FERRET: ferretIcon,
    RABBIT: rabbitIcon,
    PIGGY_INDIAN: pigIcon,
    CAT: catIcon
  }

  useEffect(() => {
    setQuestionLabelMessage(questionMessage)
  }, [questionMessage])

  useEffect(() => {
    setNewAnswerMessage(answerMessage)
  }, [answerMessage])

  useEffect(() => {
    setNotificationRead(answerRead)
  }, [answerRead])

  useEffect(() => {
    setQuestionLabelMessage(questionMessage)
  }, [questionMessage])

  useEffect(() => {
    setNewAnswerMessage(answerMessage)
  }, [answerMessage])

  useEffect(() => {
    setNotificationRead(answerRead)
  }, [answerRead])

  const handleOpen = async () => {
    setOpen(!open)

    if (solicitationId && !notificationRead && newAnswerMessage) {
      const response = await updateSolicitation(solicitationId, {
        answerRead: true,
        kind
      })

      const responseData = response.data

      if (responseData) {
        setNotificationRead(responseData.answerRead)
        handleUpdateSolicitation(solicitationId, responseData)
      } else {
        Swal.fire({
          title: '<h3 style=\'color: #000; font-size: 24px; font-weight: 700; font-family: "Nunito"\'>Erro!</h3>',
          html: '<p style="color: #000;">Não foi possível enviar sua solicitação, tente novamente</p>',
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          background: '#fff'
        })
      }
    }
  }

  const handleSetNewQuestionMessage = (e) => {
    const updatedQuestionMessage = e.target.value
    setNewQuestionMessage(updatedQuestionMessage)
  }

  const handleSubmitScheduling = async () => {
    setIsSubmitLoading(true)
    const { professional } = JSON.parse(localStorage.getItem('userData'))
    const response = await sendSolicitation({
      professionalId: professional.id,
      referenceId: id,
      kind: isOverbook
        ? SOLICITATION_CATEGORY.OVERBOOK_UPDATE
        : SOLICITATION_CATEGORY.SCHEDULING_UPDATE,
      questionMessage: newQuestionMessage,
      solicitation: {
        date: moment(date).utc(),
        userName: userName,
        service: {
          id: service.id,
          name: service.name
        },
        additionalServices: additionalServices.map(({ id }) => id),
        pet: {
          name: pet.name,
          castrated: pet.castrated,
          temperament: pet.temperament,
          breed: {
            id: pet.breed.id,
            name: pet.breed.name,
            type: pet.breed.type
          }
        },
        obs: obs
      }
    })

    const responseData = response.data

    if (responseData) {
      setNewAnswerMessage(responseData.answerMessage)
      setQuestionLabelMessage(responseData.questionMessage)
      setNewQuestionMessage('')
      const newSolicitation = {
        ...responseData,
        solicitation: {
          ...responseData.solicitation,
          additionalServices: additionalServices.map(({ id, name }) => ({ _id: id, name }))
        }
      }
      handleUpdateSolicitation(solicitationId, newSolicitation)
    } else {
      Swal.fire({
        title: '<h3 style=\'color: #000; font-size: 24px; font-weight: 700; font-family: "Nunito"\'>Erro!</h3>',
        html: '<p style="color: #000;">Não foi possível enviar sua solicitação, tente novamente</p>',
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        background: '#fff'
      })
    }

    setIsSubmitLoading(false)
  }

  const additionalServicesList = additionalServices?.map((additionalService) => additionalService.name)

  return (
    <div>
      <Header isPast={isPast(parseISO(date))}>
        <SchedulerTime>{timeStart}-{timeEnd}</SchedulerTime>
        { !notificationRead && answerMessage && (
          <NotificationCircle>1</NotificationCircle>
        )}
      </Header>
      <Body>
        <Item className={open ? '' : 'with-no-border'}>
          <Icon>
            <img src={serviceIcon} alt="serviço" />
          </Icon>
          <Description>
            {service.name}
            {!!additionalServices?.length && (
              <AdditionalServices open={open}>+ {additionalServicesList.sort().join(', ')}</AdditionalServices>
            )}
          </Description>
        </Item>
        {open && (
          <>
            <Item>
              <Icon>
                <img src={personIcon} alt="cliente" />
              </Icon>
              <Description>{userName}</Description>
            </Item>
            <Item>
              <Icon>
                <img src={breedIcons[pet.breed.type]} alt={pet.breed.type} />
              </Icon>
              <Description>{pet.name} | {pet.breed.name}</Description>
            </Item>
            <Item className='with-no-border'>
              <Icon>
                <img src={obsIcon} alt="observação" />
              </Icon>
              <Description>{obs || 'Sem observação.'}</Description>
            </Item>
            { questionLabelMessage && (
              <QuestionContent>
                <Icon>
                  <img src={chatProcessingIcon} alt="conversa" />
                </Icon>
                <div className='flex-column'>
                  <Question>{questionLabelMessage}</Question>
                  { !newAnswerMessage && (
                    <PendingAnswer>Resposta pendente</PendingAnswer>
                  )}
                  { newAnswerMessage && (
                    <PendingAnswer>- {newAnswerMessage}</PendingAnswer>
                  )}
                </div>
              </QuestionContent>
            )}
            <TextAreaContent>
              <Textarea
                label='Solicitação para recepção (obrigatório)'
                name='schedulingMessage'
                placeholder='Escreva aqui sua solicitação'
                maxLength={255}
                value={newQuestionMessage}
                onChange={handleSetNewQuestionMessage}
              />
              <MaxCaracters>{newQuestionMessage.length}/255</MaxCaracters>
            </TextAreaContent>
            <ButtonSubmit onClick={handleSubmitScheduling} disabled={isSubmitLoading || newQuestionMessage === ''}>
              Solicitar alteração
            </ButtonSubmit>
          </>
        )}
      </Body>
      <Footer>
        <ButtonOpen onClick={handleOpen}>
          {open ? (<FaChevronUp size='21' color='#01878E' />) : (<FaChevronDown size='21' color='#01878E' />)}
        </ButtonOpen>
      </Footer>
    </div>
  )
}

export default Scheduling
